import React, { useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import api from "../../services/api";
import CustomizedSnackbars from "../../components/alert/Alert";
import logo from "../../images/perto-logo.png";
import { Grid, ThemeProvider, createTheme } from "@mui/material";

let text = "";
let tipo = "";

export default function RedefinirSenha(props) {
  const [token] = useState(props.match.params.token);
  const [canal] = useState(props.match.params.canal);
  const [direcionar, setDirecionar] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [user, setUser] = useState("");
  const [confirmacaoSenha, setConfirmacaoSenha] = useState("");
  // const history = useHistory();
  const [alerta, setAlerta] = useState(false);
  const [fim, setFim] = useState(false);
  const [tokenOk, setTokenOk] = useState(false);

  useEffect(() => {
    if (!token || token === "") {
      text = "Link inválido.";
      tipo = "warning";
      alertMsg();
      setMensagem("Link inválido.");
      return;
    }

    if (canal === "painel-admin") {
      setDirecionar("https://painel.pertoeducacao.com.br/login");
    }
    if (canal === "painel-escola") {
      setDirecionar("https://escola.pertoeducacao.com.br/login");
    }

    api
      .get("usuarios/validarTokenRedefinicaoSenha", { token })
      .then((res) => {
        setUser(res.usuarioNome);
        setTokenOk(true);
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            text = `Token expirado`;
            tipo = "error";
            alertMsg();
            setMensagem("Link inválido.");
            return;
          default:
            text = `Dados inválidos`;
            tipo = "error";
            alertMsg();
            return;
        }
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (senha.length < 3) {
      text = "A senha deve ter no mínimo 3 caracteres.";
      tipo = "warning";
      alertMsg();
      return;
    }

    if (senha !== confirmacaoSenha) {
      text = "A confirmação é diferente da senha informada.";
      tipo = "warning";
      alertMsg();
      return;
    }

    api
      .post("usuarios/redefinirSenha", { token, senha })
      .then((res) => {
        setFim(true);
        if (direcionar) {
          setMensagem("Senha redefinida com sucesso!");
        } else {
          setMensagem(
            "Senha redefinida com sucesso. Esta página já pode ser fechada e já é possível efetuar o login com a nova senha"
          );
        }
      })
      .catch(
        () => console.log("erro")
        // this.setState({
        //   mensagem: "Não foi possível estabelecer uma conexão com o servidor.",
        // })
      );
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: "1%" }}
      >
        <div
          style={{
            width: window.innerWidth < 800 ? "100%" : "450px",
            backgroundColor: "white",
            textAlign: "center",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div style={{ background: "#952CAE", padding: 20, color: "white" }}>
              <img src={logo} alt="logo" style={{ width: 200 }} />
              <h4>Redefinir senha</h4>
            </div>
            {mensagem !== "" && (
              <h4 style={{ color: fim ? "green" : "red" }}>{mensagem}</h4>
            )}
            {tokenOk && !fim && (
              <Stack spacing={1} sx={{ width: "100%" }}>
                <TextField
                  disabled
                  style={{ margin: "10px", background: "#FFFF" }}
                  id="USER"
                  label="Usuário"
                  variant="outlined"
                  defaultValue={user}
                />
                <TextField
                  style={{ margin: "10px", background: "#FFFF" }}
                  id="SENHA"
                  type="password"
                  label="Senha"
                  variant="outlined"
                  onChange={(event) => setSenha(event.target.value)}
                />
                <TextField
                  style={{ margin: "10px", background: "#FFFF" }}
                  id="CONFIRME"
                  type="password"
                  label="Confirme a senha"
                  variant="outlined"
                  onChange={(event) => setConfirmacaoSenha(event.target.value)}
                />

                {!fim ? (
                  <div style={{ display: "contents" }}>
                    <ThemeProvider theme={theme}>
                      <Button
                        style={{ margin: "30px", color: "white" }}
                        color="primary"
                        type="submit"
                        variant="contained"
                      >
                        Confirmar
                      </Button>
                    </ThemeProvider>
                  </div>
                ) : (
                  <ThemeProvider theme={theme}>
                    <Button
                      style={{ margin: "30px", color: "white" }}
                      color="info"
                      // onClick={() => history.push(`/login`)}
                      variant="contained"
                    >
                      Voltar para o login
                    </Button>
                  </ThemeProvider>
                )}
              </Stack>
            )}

            {fim && (
              <>
                <h4 style={{ color: fim ? "green" : "red" }}>{mensagem}</h4>
                {direcionar && (
                  <Stack spacing={1} sx={{ width: "100%" }}>
                    <Button
                      style={{ margin: "30px", color: "white" }}
                      color="info"
                      // onClick={() => history.push(`/login`)}
                      variant="contained"
                    >
                      <a
                        style={{ textDecoration: "none", color: "white" }}
                        href={direcionar}
                      >
                        Voltar para o login
                      </a>
                      {/* Voltar para o login */}
                    </Button>
                  </Stack>
                )}
              </>
            )}

            {alerta && (
              <CustomizedSnackbars
                texto={text}
                tipo={tipo}
              ></CustomizedSnackbars>
            )}
          </form>
        </div>
      </Grid>
    </div>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#952CAE",
    },
  },
});
